const buttonTab = document.querySelectorAll('.delivery__button-tab');
const contentTab = document.querySelectorAll('.delivery__tab-content');

buttonTab.forEach(button => {
  button.addEventListener('click', () => {

    const tabId = button.getAttribute('data-tab');
    const content = document.querySelector('#' + tabId);

    contentTab.forEach(el => el.classList.add('hiddenTab'));
    buttonTab.forEach(el => el.classList.remove('activeTab'));

    content.classList.remove('hiddenTab');
    button.classList.add('activeTab');

  })
})